<mat-card appearance="outlined">
  <mat-card-title class="text-primary d-flex align-items-center pb-3">
    {{ 'VOUCHER.CREATE.CLIENT_INSTALLATIONS' | translate }}
  </mat-card-title>
  <mat-card-content>
    <div *userPermission="'USER_CAN_WRITE'" class="w-100 d-flex justify-content-end">
      <button
        mat-stroked-button
        class="mr-2"
        color="primary"
        type="button"
        [disabled]="downloadLogStatus !== 'NO_LOG'"
        (click)="logRequest()"
      >
        {{ 'VOUCHER.CLIENT_INSTALLATIONS.REQUEST_LOG' | translate }}
      </button>
      <button mat-flat-button type="button" color="primary" [disabled]="downloadLogStatus !== 'READY'" (click)="downloadLog()">
        {{ 'VOUCHER.CLIENT_INSTALLATIONS.DOWNLOAD_LOG' | translate }}
      </button>
    </div>

    <mat-list>
      <!--CLIENT_ID-->
      <mat-list-item class="pb-2">
        <h4 class="font-weight-bold" mat-line>
          {{ 'VOUCHER.CLIENT_INSTALLATIONS.CLIENT_ID' | translate }}
        </h4>
        <div mat-line>
          {{ voucher().client_installation?.client_id ?? 'Invalid CLIENT ID' }}
        </div>
      </mat-list-item>
      <mat-divider></mat-divider>
      <!--APPLICATION_TYPE-->
      <mat-list-item class="pb-2">
        <h4 class="font-weight-bold" mat-line>
          {{ 'VOUCHER.CLIENT_INSTALLATIONS.APPLICATION_TYPE' | translate }}
        </h4>
        <div mat-line>
          {{ voucher().client_installation?.type ?? 'Invalid TYPE' }}
        </div>
      </mat-list-item>
      <mat-divider></mat-divider>
      <!--INSTANCES-->
      @if (voucher().client_installation?.instances) {
      <div class="d-flex align-items-center">
        <mat-form-field class="w-100 mr-3">
          <mat-label>{{ 'VOUCHER.CLIENT_INSTALLATIONS.INSTANCES' | translate }}</mat-label>
          <input
            matInput
            type="number"
            [formControl]="formControlInstaces"
            [value]="1"
            [min]="0"
            [placeholder]="'VOUCHER.CLIENT_INSTALLATIONS.INSTANCES' | translate"
            [readonly]="disableModifyInstances"
          />
        </mat-form-field>
        <button *userPermission="'USER_CAN_WRITE'" mat-icon-button (click)="disableModifyInstances = !disableModifyInstances">
          <mat-icon>edit</mat-icon>
        </button>
      </div>
      }
    </mat-list>
  </mat-card-content>
</mat-card>
